import React, { useState } from "react";
import { useNavigate, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../../redux/actions/authActions';
import RankrSidebarMenu from "./RankrSidebarMenu";

const RankrDashboard = () => {
  const authState = useSelector(state => state.authReducer);
  const { isLoggedIn } = authState;
  const [userName] = useState(authState.user.name);
  const [currentPage, setCurrentPage] = useState('dashboard');
  const [selectedRole, setSelectedRole] = useState('Student'); // Default role
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout());
    navigate("/rankr");
  };

  const [currentLabel, setCurrentLabel] = useState('');

  const handleSelectPage = (page, label) => {
    setCurrentPage(page);
    setCurrentLabel(label);
  };

  return (
    <div className="flex flex-col min-h-screen font-sans text-gray-800 bg-gradient-to-br from-blue-400 to-blue-600">
      {/* HEADER */}
      <header className="flex justify-between items-center px-6 py-4 bg-blue-500 shadow-md sticky top-0 z-50">
        {/* Logo */}
        <div
          onClick={() => navigate('/rankr')}
          className="text-3xl font-extrabold text-white tracking-wide cursor-pointer"
        >
          LEGEND
        </div>

        {/* Desktop Nav */}
        <nav className="hidden md:flex space-x-6 font-medium">
          {['Student', 'Faculty', 'Advocate', 'Judges', 'Professionals', 'Management', 'Partner', 'Admin'].map(role => (
            <button
              key={role}
              onClick={() => setSelectedRole(role)}
              className={`transition px-2 py-1 rounded ${
                selectedRole === role
                  ? 'bg-blue-500 text-white font-semibold'
                  : 'hover:text-white hover:bg-blue-600'
              }`}
            >
              {role}
            </button>
          ))}
        </nav>

        {/* Desktop User & Logout */}
        <div className="hidden md:flex items-center space-x-4">
          {isLoggedIn && (
            <>
              <span className="text-white font-medium">Welcome, {userName}</span>
              <button
                onClick={handleLogout}
                className="w-9 h-9 flex items-center justify-center text-lg bg-red-500 text-white rounded-full hover:bg-red-600 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          )}
        </div>

        {/* Mobile Menu Toggle */}
        <div className="md:hidden flex items-center">
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="text-xl text-white bg-blue-500 px-3 py-1 rounded flex justify-center"
            aria-label="Toggle Menu"
          >
            {isMobileMenuOpen ? "×" : "☰"}
          </button>
        </div>
      </header>

      {/* Mobile Menu Drawer */}
      {isMobileMenuOpen && (
        <nav className="md:hidden bg-blue-400 flex flex-col px-6 py-4 space-y-3">
          {['Student', 'Faculty', 'Advocate', 'Judges', 'Professionals', 'Management', 'Partner', 'Admin'].map(role => (
            <button
              key={role}
              onClick={() => {
                setSelectedRole(role);
                setIsMobileMenuOpen(false);
              }}
              className={`text-left px-4 py-2 rounded ${
                selectedRole === role
                  ? 'bg-blue-600 font-semibold text-white'
                  : 'hover:text-white hover:bg-blue-500'
              }`}
            >
              {role}
            </button>
          ))}
          {isLoggedIn && (
            <div className="mt-4 border-t pt-3 border-white text-white">
              <p className="mb-2">Welcome, {userName}</p>
              {/* <div className="flex flex-col">
                <SidebarMenu selectedRole={selectedRole} onSelectPage={setCurrentPage} />
              </div> */}
              <button
                onClick={handleLogout}
                className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 transition"
              >
                Logout
              </button>
            </div>
          )}
        </nav>
      )}

      {/* MAIN SECTION */}
      <div className="flex flex-1 min-h-0">
        {/* <SidebarMenu selectedRole={selectedRole} onSelectPage={setCurrentPage} /> */}
        <RankrSidebarMenu selectedRole={selectedRole} onSelectPage={handleSelectPage} />
        <main className="flex-1 bg-gray-600 text-white p-4 md:p-8 overflow-y-auto">
          <div className="text-lg font-semibold text-yellow-200">
            Welcome to your dashboard, {userName}!
          </div>
          {currentLabel && (
            <div className="text-md text-white mb-4">
              Selected Menu: <span className="font-bold text-yellow-300">{currentLabel}</span>
            </div>
          )}
        </main>
      </div>

      {/* FOOTER */}
      <footer className="bg-blue-500 text-white py-10 px-4 sm:px-6 md:px-20">
        <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left">
          <p className="text-sm">&copy; 2025 Think5Whys Global DeepTech Solutions. All rights reserved.</p>
          <div className="flex space-x-6 mt-4 md:mt-0 text-sm">
            <Link to="/about-us" className="text-white hover:text-yellow-200 transition">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-yellow-200 transition">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-yellow-200 transition">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-yellow-200 transition">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default RankrDashboard;
